<template lang="pug">
div
  Form(:data="physical_location", :isSubmitting="isSubmitting", @submit="create")
</template>

<script>
import Form from '../shared/Form.vue'
import usePhysicalLocationAdd from './usePhysicalLocationAdd'

export default {
  components: {
    Form,
  },

  setup() {
    const { create, physical_location, isSubmitting } = usePhysicalLocationAdd()

    return {
      physical_location,
      create,
      isSubmitting,
    }
  },
}
</script>
